"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GtmDataLayerHelper = /** @class */ (function () {
    function GtmDataLayerHelper(initDefaultContext) {
        this.initDefaultContext = initDefaultContext;
        if (!window.dataLayer) {
            window.dataLayer = [];
        }
    }
    GtmDataLayerHelper.prototype.loadDefaultContext = function (data) {
        if (data && data.context) {
            data.context.timestamp = Date.now();
            data.context = Object.assign(data.context, this.initDefaultContext());
        }
    };
    GtmDataLayerHelper.prototype.logDataLayerEvent = function (data) {
        this.loadDefaultContext(data);
        window.dataLayer.push(data);
    };
    return GtmDataLayerHelper;
}());
exports.GtmDataLayerHelper = GtmDataLayerHelper;
//# sourceMappingURL=GtmDataLayerHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/helpers/GtmDataLayerHelper.js
// module id = 953
// module chunks = 1